<template>
    <section>
        <level-modal/>
        <activity-request-modal :activityMember="activityMember" :activity="activity" :isRepeatableDayOfWeek="activity.isRepeatableDayOfWeek" @before-close="activityApplyToggle"/>
        <div class="container">
            <div class="row ">
                <div class="col text-center mobile_padding">
                    <img :src="activity.thumbnail" @error="activity.thumbnail = require('@/assets/icon/'+activity.categoryClazz+'_on.png')">
                    <br/>

                    <button v-if="$auth.check() && $auth.user().roleNames.includes('ADMIN')" type="button" class="btn btn-outline-danger"
                    style="margin-top:20px;margin-bottom: 20px; color:##696969; border-color: #d9d9d9; border-radius: 30px;" @click="$router.push({ name: 'activityModify', params: { id: $route.params.id }})">활동 수정</button>

                </div>
                <div class="col-md-6" style="margin-right: 5%;">
                    <h4 class="pb-3 text-center" style="line-height: 36px;">
                        <span class="notify-badge-title" :style="'background-color:'+activity.categoryColor">{{activity.categoryName}}</span>
                        {{activity.title}}
                    </h4>

                    <div class="form-row">
                        <div class="form-group col-3 text-center">
                            활동기간
                        </div>
                        <div class="form-group col text-left">
                            {{$root.$children[0].dateFormat(activity.activityStartDate,'YYYY.MM.DD (ddd) H시 mm분')}} ~ {{$root.$children[0].dateFormat(activity.activityEndDate,'YYYY.MM.DD (ddd) H시 mm분')}}
                            <!--<span class="primary">
                                ({{moment.duration(new Date(activity.activityEndDate) - new Date(activity.activityStartDate)).asMinutes() > 300 ?
                                parseInt(moment.duration(new Date(activity.activityEndDate) - new Date(activity.activityStartDate)).asHours())+'시간' :
                                moment.duration(new Date(activity.activityEndDate) - new Date(activity.activityStartDate)).asMinutes()+'분'}})
                            </span>-->
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-3 text-center">
                            신청마감
                        </div>
                        <div class="form-group col text-left">
                            {{$root.$children[0].dateFormat(activity.joinDueDate,'YYYY.MM.DD (ddd) HH시 mm분')}}

                            <span v-if="!activity.activityJoinAbleNow" style="color:red; font-size:14px;"> 신청마감</span>
                            <span v-else style="color:red; font-size:14px;"> ({{applyLeftMinute < 1 ? "신청마감": (applyLeftMinute < 60) ? applyLeftMinute + "분 남음" : '신청접수중'}}
                                {{activity.isRepeatableDayOfWeek ? '-요일선택':''}}
                                )</span>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-3 text-center">
                            모집인원
                        </div>
                        <div class="form-group col text-left">
                            {{activity.memberCount}}명 / {{activity.joinAblePersonCount}}명
                            <span  class="" style="font-size:14px; color:#0077ff;">
                                (봉사시간 {{!!activity.volunteerMinute ? (activity.volunteerMinute > 60 ? `${parseInt(activity.volunteerMinute/60)}시간 ${activity.volunteerMinute%60}분 ` : activity.volunteerMinute + '분') : '미'}}인정)
                            </span>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-3 text-center">
                            레벨제한
                        </div>
                        <div class="form-group col text-left" v-if="(activity.minJoinLimitByLevel == 0 && activity.maxJoinLimitByLevel == 10)">
                            없음
                        </div>
                        <div class="form-group col text-left" v-else>
                            {{activity.minJoinLimitByLevel + '레벨 이상  ~'}}
                            {{activity.maxJoinLimitByLevel + '레벨 이하' }}
                            <button class="btn btn-outline-primary btn-sm" @click="levelInfo()">?</button>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-3 text-center">
                            나이제한
                        </div>
                        <div class="form-group col text-left" v-if="(activity.minJoinLimitByAge == 0 && activity.maxJoinLimitByAge == 100)">
                            없음
                        </div>
                        <div class="form-group col text-left" v-else>
                            {{'만 '+ activity.minJoinLimitByAge+'세 이상  ~'  }}
                          <span v-show="activity.maxJoinLimitByAge !== 100">{{'만 '+ activity.maxJoinLimitByAge+'세 이하' }}</span>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-3 text-center">
                            참가비용
                        </div>
                        <div class="form-group col text-left" v-if="activity.activityJoinCost > 0">
                            {{activity.activityJoinCost}}원
                            <img :src="require('@/assets/icon/pay.png')" style="width:48px;" @click="openPayInfoPopup"/>
                        </div>
                        <div class="form-group col text-left" v-else>
                            무료
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-3 text-center">
                            회원 제한
                        </div>
                        <div class="form-group col text-left" >
                            {{activity.karaRegularMemberOnly ? "카라 정기 회원만 신청 가능" : "제한 없음"}}
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-3 text-center">
                            주소
                        </div>
                        <div class="form-group col text-left" >
                            {{activity.visibleAddressToJoinerOnly && !activityMember.memberId ? '신청자 공개' : activity.activityPlaceAddress + ' ' + activity.activityPlaceName}}
                            <img :src="require('@/assets/icon/map.png')" style="width:58px;" @click="toggleMapModal()"  v-if="!activity.visibleAddressToJoinerOnly || activityMember.memberId" />
                        </div>
                    </div>


                    <div class="form-row">
                        <div class="form-group col-md-12 text-center text-primary">
                            <span v-for="tag in activity.activityTags.split('#')">
                                <router-link
                                             :to="{name : 'activitySearch',
                                             params : { size:'10', page:'0', target:'activityTags', value:tag, query:`activityTags:${!!tag ? tag.replace('#','') : ''}` }}">
                                    {{tag ? '#' : ''}}{{tag}}
                                </router-link>
                            </span>
                        </div>
                    </div>


                </div>
            </div>
            <div class="row">
                <ShareButtons></ShareButtons>

                <div class="col-md-6">
                    <div class="form-row">

                        <div class="form-group col" v-on:click="activityInterest()">
                            <button class="btn" :class="{'btn-danger' : activityMember.isInterested, 'btn-primary' : !!!activityMember.isInterested}">
                                <i class="fa fa-check"></i> 관심{{activityMember.isInterested ? '취소' : '등록'}} ({{activity.interestCount}})
                            </button>
                        </div>

                        <div class="form-group col" v-if="activity.activityJoinAbleNow">
                            <div v-if="$auth.check()">
                                <div v-if="applyLeftMinute < 0" >

                                    <span>신청 마감되었습니다.
                                        <a style="color:red;" v-if="['REQUESTED','WAITING',null,'APPROVED'].includes(activityMember.status) && activityMember.isRegistered"  v-on:click="activityApply()" >
                                           (신청 취소 하기)
                                        </a>
                                    </span>
                                </div>

                                <button v-else-if="['REQUESTED','WAITING',null].includes(activityMember.status)"  v-on:click="activityApply()" class="btn" :class="{'btn-danger' : activityMember.isRegistered, 'btn-outline-primary' : !!!activityMember.isRegistered}">
                                    <i class="fa fa-check"></i> 신청{{activityMember.isRegistered ? '취소' : '하기'}}
                                </button>

                                <button v-else-if="activityMember.status == 'APPROVED' && activity.activityJoinCost > 0" type="button"  class="btn btn-outline-danger" @click="requestPayBefore"> 결제 하기 </button>

                                <button v-else-if="activityMember.status == 'PAID' || (activityMember.status == 'APPROVED'  && activity.activityJoinCost == 0)" type="button"  class="btn btn-outline-success"> 신청 완료 </button>

                                <button v-else-if="activityMember.status == 'REJECTED'" type="button"  class="btn btn-outline-danger"> 반려되었습니다.</button>

                                <button v-else-if="activityMember.status == 'NOSHOW'" type="button"  class="btn btn-outline-danger"> 불참하셨습니다.</button>

                                <button v-else-if="activityMember.status == 'COMPLETED'" type="button"  class="btn btn-outline-success"> 참여 완료하셨습니다.</button>

                                <span v-else>{{activityMember.status}}</span>

                            </div>
                            <div v-else>
                                <button v-on:click="popupLogin()" class="btn btn-outline-primary">
                                    <i class="fa fa-check"></i> 신청 하기
                                </button>
                            </div>
                        </div>



                        <div class="form-group col" v-else>
                            <button v-on:click="etcAlert()" class="btn btn-outline-primary">
                                <i class="fa fa-check"></i> 신청 하기
                            </button>
                            <!--<button class="btn">
                                <i class="fa fa-check"></i> 별도연락
                            </button>-->
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="container">
            <div class="row">
                <div class="col-md-12 ">
                    <nav>
                        <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                            <a class="nav-item nav-link active nav_title" id="nav-home-tab" data-toggle="tab" href="#nav-home"
                               role="tab" aria-controls="nav-home" aria-selected="true">상세정보</a>
                            <a class="nav-item nav-link nav_title" id="nav-profile-tab" data-toggle="tab" href="#nav-profile"
                               role="tab" aria-controls="nav-profile" aria-selected="false">문의 <span v-show="activity.replyCount>0">({{activity.replyCount}})</span></a>
                            <a class="nav-item nav-link nav_title" id="nav-contact-tab" data-toggle="tab" href="#nav-contact"
                               role="tab" aria-controls="nav-contact" aria-selected="false">신청/취소 안내</a>
                            <a class="nav-item nav-link nav_title" id="nav-about-tab" data-toggle="tab" href="#nav-about"
                               role="tab" aria-controls="nav-about" aria-selected="false">후기 <span v-show="activity.reviewCount>0">({{activity.reviewCount}})</span></a>
                        </div>
                    </nav>
                    <div class="tab-content .navbar-brandpy-3 px-3 px-sm-0" id="nav-tabContent">
                        <div class="tab-pane fade show active" id="nav-home" role="tabpanel"
                             aria-labelledby="nav-home-tab">
                            <ActivityDetail :msg="activity.activityDetails" :activityNotice="activity.activityNotice"></ActivityDetail>
                        </div>
                        <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                            <ActivityQnA class="nav_title"></ActivityQnA>
                        </div>
                        <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                            <ActivityRegistCancel :msg="activity.activityCancelPenaltyNotice" ></ActivityRegistCancel>
                        </div>
                        <div class="tab-pane fade" id="nav-about" role="tabpanel" aria-labelledby="nav-about-tab">
                            <ActivityReview :activity-member-status="activityMember.status"></ActivityReview>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <ActivityPlaceMapPopup :lat="activity.lat" :lng="activity.lng" ></ActivityPlaceMapPopup>

    </section>


</template>
<script>
    /* eslint-disable */
    import ShareButtons from "../../components/ShareButtons";
    import ActivityQnA from "../../components/activity/ActivityQnA";
    import ActivityRegistCancel from "../../components/activity/ActivityRegistCancel";
    import ActivityDetail from "../../components/activity/ActivityDetail";
    import ActivityReview from "../../components/activity/ActivityReview";
    import ActivityPlaceMapPopup from "../../components/activity/ActivityPlaceMapPopup";
    import ActivityRequestModal from "../../components/activity/ActivityRequestModal";
    import moment from 'moment';
    import Vue from 'vue'
    import LevelModal from '../../components/LevelModal.vue'

    export default {
        name: 'ActivityShow',
        components: {
            ShareButtons, ActivityQnA, ActivityDetail, ActivityRegistCancel, ActivityReview, ActivityPlaceMapPopup, LevelModal, ActivityRequestModal
        },
        data() {
            return {
                activity: {
                    activityTags: '',
                    replyCount : 0,
                    memberCount : 0,
                    reviewCount : 0,
                    interestCount : 0
                },
                activityMember : {
                    isInterested : false,
                    isRegistered : false,
                    isRepeatableMon : false,
                    isRepeatableTue : false,
                    isRepeatableWed : false,
                    isRepeatableThu : false,
                    isRepeatableFri : false,
                    isRepeatableSat : false,
                    isRepeatableSun : false,
                    isAppliedLunchbox: null,
                    disableAppliedLunchbox: null,
                    isConfirmDayOfWeek: true,
                    transportation: '',
                },
                applyLeftMinute: 0,
                isRepeatableDayOfWeek: false,
            }

        },
        methods: {
            get() {
                let me = this;
                this.axios.get(process.env.VUE_APP_PUBLIC_API_URL + '/activity/' + this.$route.params.id)
                    .then(function (res) {
                        me.activity = res.data;
                        me.applyLeftMinute = moment(me.activity.joinDueDate).diff(moment(), 'minute')
                        //me.applyLeftMinute = moment(me.activity.activityEndDate).diff(moment(), 'minute')
                        me.isRepeatableDayOfWeek = me.activity.isRepeatableDayOfWeek;
                    }).catch(function (error) {
                    console.log(error);
                    location.href="/";
                    //alert(' 에러');
                });
            },
            getActivityMemeberInfo() {
                let me = this;
                this.axios.get(process.env.VUE_APP_PUBLIC_API_URL + '/activity/' + this.$route.params.id + '/' + this.$auth.user().id)
                    .then(function (res) {
                        me.activityMember = res.data;
                        if(!me.activityMember.memberId) {
                            console.log('here')
                            me.activityMember.activityId = me.$route.params.id
                            me.activityMember.memberId = me.$auth.user().id
                        }
                    }).catch(function (error) {
                    console.log(error);
                    //alert(' 에러');
                });
            },
            activityApply() {
                //<span v-if="activity.minJoinLimitByLevel -1 > $auth.user().level || activity.maxJoinLimitByLevel < $auth.user().level">레벨 조건이 부합하지 않습니다.</span>
                //<span v-else-if="activity.minJoinLimitByAge > $auth.user().age || activity.maxJoinLimitByAge < $auth.user().age">나이조건이 부합하지 않습니다.</span>
                //<span v-else-if="activity.joinAblePersonCount <= activity.memberCount">신청인원이 다 찼습니다. <br/>관심등록하시면 자리났을때 알려드릴게요</span>
                if(this.$auth.check()) {
                    if(!this.activityMember.isRegistered) {

                        if(this.activity.karaRegularMemberOnly && !this.$auth.user().isKaraRegularMember) {
                            this.$root.$children[0].commonDialog('활동 신청', '카라 정기 회원만 참여 가능한 활동입니다.');
                            return;
                        }

                        if(this.activity.minJoinLimitByLevel -1 > this.$auth.user().level || this.activity.maxJoinLimitByLevel < this.$auth.user().level) {
                            this.$root.$children[0].commonDialog('활동 신청', '레벨 조건이 부합하지 않습니다.');
                            return;
                        }
                        if(this.activity.minJoinLimitByAge > this.$root.$children[0].getAge(this.$auth.user().age) || this.activity.maxJoinLimitByAge < this.$root.$children[0].getAge(this.$auth.user().age)) {
                            this.$root.$children[0].commonDialog('활동 신청', '나이조건이 부합하지 않습니다.');
                            return;
                        }
                        if(this.activity.joinAblePersonCount <= this.activity.memberCount) {
                            this.$root.$children[0].commonDialog('활동 신청', '신청인원이 다 찼습니다. <br/>관심등록하시면 자리났을때 알려드릴게요');
                            return;
                        }
                    }

                    this.$modal.show('ActivityRequestModal');
                } else {
                    this.popupLogin()
                }
            },
            activityInterest() {
                if(this.$auth.check()) {
                    let toggleText = this.activityMember.isInterested ? '취소' : '등록';
                    this.popupToggle(`관심 ${toggleText}`, `관심 ${toggleText} 하시겠습니까?`, this.activityInterestToggle)
                } else {
                    this.popupLogin()
                }
            },

            popupLogin() {
                this.$modal.show('dialog', {
                    title: '회원 전용',
                    text: '로그인이 필요합니다.',
                    buttons: [
                        {
                            title: '로그인 하기',
                            handler: () => {
                                this.$router.push({ name: 'login', params: { ref: this.$router.currentRoute.path }});
                                this.$modal.hide('dialog');
                            }

                        },
                        {
                            title: '닫기'
                        }
                    ]
                })
            },

            etcAlert() {
                this.$modal.show('dialog', {
                    title: '활동 신청',
                    text: '온라인 신청이 불가한 활동입니다. 별도 연락 부탁드립니다.',
                    buttons: [
                        {
                            title: '닫기'
                        }
                    ]
                })
            },

            activityApplyToggle(activityMember) {
                let me = this;
                this.axios.put(process.env.VUE_APP_ACTIVITY_API_URL + `/activityMember`,activityMember)
                    .then(function (res) {
                        //me.activity.interestCount = res.data.interestCount;
                        //me.activity.memberCount = res.data.memberCount;
                        //me.activity.replyCount = res.data.replyCount;
                        me.getActivityMemeberInfo()
                        if(res.data) me.$root.$children[0].commonDialog('활동신청','활동이 신청되었습니다.');
                        else me.$root.$children[0].commonDialog('활동신청','활동이 취소되었습니다.');
                    }).catch(function (error) {
                    console.log(error);
                });
            },

            activityInterestToggle() {
                let me = this;
                this.axios.put(process.env.VUE_APP_ACTIVITY_API_URL + `/interest/${this.$route.params.id}/${this.$auth.user().id}`)
                    .then(function (res) {
                        me.activity.interestCount = res.data.interestCount;
                        me.activity.memberCount = res.data.memberCount;
                        me.activity.replyCount = res.data.replyCount;
                        me.getActivityMemeberInfo()
                    }).catch(function (error) {
                    console.log(error);
                });
            },

            popupToggle(title, text, callback) {
                this.$modal.show('dialog', {
                    title: title,
                    text: text,
                    buttons: [
                        {
                            title: title,
                            handler: () => {
                                callback();
                                this.$modal.hide('dialog');
                            }
                        },
                        {
                            title: '닫기'
                        }
                    ]
                })
            },

            requestPayBefore() {
                this.$modal.show('dialog', {
                    title: '결제 하기',
                    text: '계좌이체만 가능합니다.',
                    buttons: [
                        {
                            title: '결제 확인 요청 하기',
                            handler: () => {
                                let me = this;
                                this.axios.get(process.env.VUE_APP_PAYMENT_API_URL + `/check/${this.$route.params.id}/${this.$auth.user().id}`)
                                    .then(function (res) {
                                        me.$modal.hide('dialog');
                                        me.$root.$children[0].commonDialog('결제 확인 요청', '관리자에게 계좌 확인 요청 메세지를 보냈습니다.')
                                    }).catch(function (error) {
                                    console.log(error);
                                });

                            }
                        },
                        {
                            title: '닫기'
                        }
                    ]
                })
                /*
                let me = this;
                this.axios.get(process.env.VUE_APP_PAYMENT_API_URL + `/${this.$route.params.id}/${this.$auth.user().id}`)
                    .then(function (res) {
                        me.requestPay(res.data)
                    }).catch(function (error) {
                    console.log(error);
                });*/
            },

            requestPayAfter(uuid) { // TODO : prevent force call
                let me = this;
                this.axios.put(process.env.VUE_APP_PAYMENT_API_URL + `/${uuid}/PAID`)
                    .then(function (res) {
                        me.activityMember = res.data;
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            requestPay(uuid) {
                let me = this;
                Vue.IMP().request_pay({
                    pg: 'html5_inicis',
                    pay_method: 'card',
                    merchant_uid: uuid,
                    name: '주문명:결제테스트',
                    amount: me.activity.activityJoinCost,
                    buyer_email: me.$auth.user().email,
                    buyer_name: me.$auth.user().name,
                    buyer_tel: me.$auth.user().phoneNumber,
                    buyer_addr: me.$auth.user().address,
                    //buyer_postcode: '123-456'
                }, (result_success) => {
                    //성공할 때 실행 될 콜백 함수
                    let msg = '결제가 완료되었습니다.';
                    msg += '<br>고유ID : ' + result_success.imp_uid;
                    msg += '<br>상점 거래ID : ' + result_success.merchant_uid;
                    msg += '<br>결제 금액 : ' + result_success.paid_amount;
                    msg += '<br>카드 승인번호 : ' + result_success.apply_num;
                    msg += '<br>확인 버튼을 눌러주세요.';

                    me.$root.$children[0].commonDialog('결제 완료',msg)
                    me.requestPayAfter(uuid);

                }, (result_failure) => {
                    //실패시 실행 될 콜백 함수
                    var msg = '결제에 실패하였습니다.';
                    msg += '에러내용 : ' + result_failure.error_msg;
                    alert(msg);
                })
            },
            toggleMapModal() {
                this.$modal.show('ActivityPlaceMapPopup', {
                    lat:this.activity.lat,
                    lng:this.activity.lng,
                    placeName:this.activity.activityPlaceAddress
                });
            },
            openPayInfoPopup() {
                this.$root.$children[0].commonDialog('결제 정보', this.activity.activityCostAccountInfo)
            },
            levelInfo() {
                this.$modal.show('LevelModal')
            },

        },

        mounted() {
            this.get()
            if(this.$auth.check())
                this.getActivityMemeberInfo()

            //Vue.use(IMP, 'imp30854117') //아임포트 회원가입 후 발급된 가맹점 고유 코드를 사용해주세요.
            //Vue.IMP().load()

            //this.certificatePhone()
        },

        created() {
            // $("html, body").animate({ scrollTop: 0 }, "fast");
        },

        watch : {
        }

    }
</script>

<style scoped>
.form-row .col-3{
    font-weight : bolder;
}

.form-group .btn {
    border-radius : 20px !important;
}
@media(max-width: 575.98px) {
    #nav-tab a {font-size:12px;padding: 10px;}
    .card-body{padding: 0px;}
    .mobile_padding {padding : 0px !important;}
}
#nav-tabContent {min-height:300px;}
.notify-badge-title {
    /*position: absolute;*/

    text-align: center;
    border-radius: 15px;
    color:white;
    padding:5px 5px;
    /*font-size:15px;*/
}
.nav-link.active{
    color: #007bff;
}
.nav_title{
    color : #343a40;
}


.popupcontainer {
    overflow-y: auto;
    max-height:600px;
    border-radius: 5px;
    background: #F7F7F7;
}
.btn-close {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    position: absolute;
    right: 20px;
    top: 5px;
}
.btn-close line {
    stroke: grey;
    stroke-width: 2;
}
.btn-close:hover line {
    stroke: black;
}
.modalHeader {
    border-bottom: 1px solid #EEE;
    padding: 1em;
    text-align: left;
}
</style>